import React from "react";
import styles from "./SolutionsImageGrid.module.scss";

const SolutionsImageGrid = ({ title, content, image }) => {
  return (
    <section className={styles.contentBlock}>
      <div className={styles.imageContainer}>
        <img src={image} alt={title} className={styles.image} />
      </div>
      <div className={styles.textContent}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.content}>
          {content.map((paragraph, index) => (
            <p key={index}>
              {paragraph.startsWith("•") ? (
                <span className={styles.listItem}>{paragraph}</span>
              ) : (
                paragraph
              )}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionsImageGrid;
